<template>
  <list v-if="$store.state.user.sections['variants']" :columns="columns" :modalCreate="modalCreate"
    :staticFilters="staticFilters" :removeLink="removeLink" :cardLink="cardLink" :isUpdate="true" :isAdd="true"
    :itemLink="itemLink" :setLink="setLink" :openItem="true" :fields="fields" :params="params" :searchDisable="true"
    @change="change" @changeFunction="changeFunction" v-model="val" />
</template>
<script>

export default {
  name: "brands",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      staticFilters: [

      ],
      params: {
        per_page: 20,
        show: 1
      },
      val: [],
      modalCreate: "season",
      fields: [
        {
          col: 'col-12',
          label: 'Название',
          key: 'name',
          type: 'field'
        },
     

      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_brand",
      itemLink: "brands",
      setLink: "brands",
      columns: [
        {
          key: "id",
          title: "id",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "name",
          title: "Название",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>

</style>
